<template>
  <Dialog
    v-model:visible="isVisible"
    :modal="true"
    :pt="dialogContentPt"
    :style="{ width: '400px' }"
  >
    <template #header>
      <div class="d-flex align-items-center gap-2">
        <i class="pi pi-folder-plus text-success"></i>
        <span>{{ headerTitle }}</span>
      </div>
    </template>
    <div class="p-fluid">
      <InputText
        v-model="folderName"
        :placeholder="$t('views.fileManager.enterFolderName')"
        class="w-full"
        size="small"
        @keyup.enter="onCreate"
      />
    </div>
    <template #footer>
      <Button
        :label="$t('common.cancel')"
        icon="pi pi-times"
        severity="secondary"
        size="small"
        @click="onCancel"
      />
      <Button
        :label="$t('common.create')"
        icon="pi pi-check"
        :loading="isLoading"
        :disabled="!folderName.trim()"
        size="small"
        @click="onCreate"
      />
    </template>
  </Dialog>
</template>

<script setup>
import { ref, computed, watch } from "vue"
import { dialogContentPt } from "@/config/dialogPt"
import { useI18n } from "vue-i18n"

const { t } = useI18n()

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  headerTitle: {
    type: String,
    default: ""
  }
})

const emit = defineEmits(["update:visible", "create", "cancel"])

const folderName = ref("")

const isVisible = computed({
  get: () => props.visible,
  set: (value) => emit("update:visible", value)
})

const headerTitle = computed(() => {
  return props.headerTitle || t("views.fileManager.createFolder")
})

const onCreate = () => {
  if (folderName.value.trim()) {
    emit("create", folderName.value.trim())
  }
}

const onCancel = () => {
  emit("cancel")
  isVisible.value = false
}

watch(isVisible, (newValue) => {
  if (!newValue) {
    folderName.value = ""
  }
})
</script>
